<!-- template html -->
<template if="showCardDetails">
    <template v-if="ifIframe">
        <div class="modalIframe">
            <div class="modalIframeInner" ref="groupCardPreviewParentEdit">
                <GroupCardCarousel class="groupCardIframe" v-if="collection" :collection="collection" :displayScaleBar="false" :messageId="messageId" />
                <!-- GroupCardCarousel component -->
            </div>
        </div>
    </template>

    <template v-else>
        <div class="preview-tabs thankyounote-block" :class="{ 'thankyou-tabs': thankYouPresent }">
            <ul class="nav nav-tabs" role="tablist" v-if="thankYouPresent">
                <li class="nav-item" role="presentation">
                    <button class="nav-link active" id="card-tab" data-toggle="tab" data-target="#card" type="button" role="tab" aria-controls="card" aria-selected="true">Card</button>
                </li>
                <li class="nav-item" role="presentation">
                    <button class="nav-link" id="thankYouNote-tab" data-toggle="tab" data-target="#thankYouNote" type="button" role="tab" aria-controls="thankYouNote" aria-selected="false">Thank You Note</button>
                </li>
            </ul>
            <div class="tab-content">
                <div class="tab-pane fade show active" id="card" role="tabpanel" aria-labelledby="card-tab">
                    <div class="modal full-screen-modal" id="full-screen-preview" tabindex="-1" aria-labelledby="fullScreen" aria-hidden="false" data-backdrop="static" data-keyboard="false">
                        <div class="modal-dialog" ref="groupCardPreviewParentEdit">
                            <GroupCardCarousel v-if="collection" :collection="collection" :displayScaleBar="false" :messageId="messageId" />
                            <!-- GroupCardCarousel component -->
                        </div>
                    </div>

                    <div class="gc-preview-btns">
                        <a href="#" class="theme-btn-lite" @click="downloadCard">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" data-v-7996aaea="" style="fill: #1e2437;">
                                <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" data-v-7996aaea=""></path>
                                <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" data-v-7996aaea=""></path>
                            </svg>
                            <span>Download as PDF</span>
                        </a>
                        <a href="#" class="theme-btn-lite" @click="openThankYouNoteModel" v-if="!thankYouPresent && isRecepient">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-send" viewBox="0 0 16 16">
                                <path d="M15.854.146a.5.5 0 0 1 .11.54l-5.819 14.547a.75.75 0 0 1-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM6.636 10.07l2.761 4.338L14.13 2.576zm6.787-8.201L1.591 6.602l4.339 2.76z" />
                            </svg>
                            <span>Say Thank You</span>
                        </a>
                        <a href="#" class="theme-btn-lite" @click="startCollection">
                            <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg" data-v-1485cac2="">
                                <path d="M23.375 4.12493C23.7361 3.76379 24.1649 3.47732 24.6367 3.28188C25.1086 3.08643 25.6143 2.98584 26.125 2.98584C26.6357 2.98584 27.1414 3.08643 27.6133 3.28188C28.0851 3.47732 28.5139 3.76379 28.875 4.12493C29.2361 4.48606 29.5226 4.91479 29.718 5.38664C29.9135 5.85848 30.0141 6.3642 30.0141 6.87493C30.0141 7.38565 29.9135 7.89137 29.718 8.36322C29.5226 8.83506 29.2361 9.26379 28.875 9.62493L10.3125 28.1874L2.75 30.2499L4.8125 22.6874L23.375 4.12493Z"
                                      stroke="rgb(30, 36, 55)"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      data-v-1485cac2=""></path>
                            </svg>
                            <span>Start your own</span>
                        </a>
                    </div>
                    <!-- gc-preview-btns -->
                </div>
                <div class="tab-pane fade" id="thankYouNote" role="tabpanel" aria-labelledby="thankYouNote-tab">
                    <div id="thank-you-note-div" v-if="thankYouPresent">
                        <ThankYouNote :callingFrom="'PGCRecipientPath'" :collectionGuid="collection" />
                    </div>
                </div>
            </div>
        </div>
        <!-- preview-tabs -->

        <div class="pgc-thankyounote-modal" id="thank-you-note-div" v-if="!thankYouPresent">
            <ThankYouNote :callingFrom="'PGCRecipientPath'" :collectionGuid="collection" />
        </div>
    </template>
</template>
<!-- template html -->
<!-- script -->
<script>
    import GroupCardCarousel from "./GroupCardCarousel.vue";
    import ThankYouNote from "../../common/ThankYouNote.vue";

    export default {
        name: "GroupCardPreviewMain",
        components: {
            GroupCardCarousel,
            ThankYouNote,
        },
        data: function () {
            return {
                collection: "",
                ifIframe: false,
                messageId: "",
                showCardDetails: false,
                thankYouPresent: false,
                showThankYouNote: false,
                isRecepient: false,
            };
        },
        mounted: function () {
            this.collection = this.$el.parentElement.getAttribute("data-collection");
            this.messageId = this.$el.parentElement.getAttribute("data-message");
            this.isRecepient = this.$el.parentElement.getAttribute("data-is-recipient") == "true" ? true : false;
            this.checkRefundedStatus();
            this.checkIframe();

            const body = document.body;
            // Add a CSS class to the <body> element
            body.classList.add("iframe-backgroup");
            if (!this.ifIframe && this.isRecepient) {
                this.isThankYouNotePresent();
            }
        },
        watch: {
            thankYouPresent(newVal) {
                if (newVal) {
                    document.body.classList.add("thank-you-body");
                } else {
                    document.body.classList.remove("thank-you-body");
                }
            }
        },
        beforeDestroy() {
            document.body.classList.remove("thank-you-body");
        },
        methods: {
            isThankYouNotePresent() {
                var collectionGuid = this.$el.parentElement.getAttribute("data-collection");
                $.ajax({
                    url: "/ThankYou/IsThankYouNotePresent",
                    data: {
                        requestId: collectionGuid,
                        requestedFromPage: "PGCRecipientPath",
                    },
                    success: (data) => {
                        if (!data.error && data.result) {
                            this.thankYouPresent = true;
                        } else if (!data.error && !data.result) {
                            this.thankYouPresent = false;
                        } else if (data.error) {
                            console.log("Error", data.message);
                        }
                    },
                    error: (xhr) => { },
                    complete: () => { },
                });
            },
            openThankYouNoteModel() {
                $("#sendThankYouNote").modal("show");
            },
            async checkRefundedStatus() {
                await fetch("/api/collectionservices/CheckIfWasRefunded?collectionGuid=" + this.collection)
                    .then((res) => res.json())
                    .then((data) => {
                        if (data == true) {
                            window.location.href = "/Error/PageNotFound";
                        } else {
                            this.showCardDetails = true;
                        }
                    })
                    .catch((err) => console.log(err.message));
            },
            downloadCard() {
                ShowLoadScreen();
                let url = "/groupcard/downloadpdf?collection=" + this.collection + "&backPage=1&privacy=false";
                var downloadWindow = window.open(url, "_blank");
                if (downloadWindow) {
                    downloadWindow.focus();
                    let interval = setInterval(() => {
                        if (downloadWindow.closed) {
                            clearInterval(interval);
                            HideLoadScreen();
                        }
                    }, 3000);
                }
            },
            startCollection() {
                location.href = "/collectionsetup/index";
            },
            checkIframe() {
                if (window.self !== window.top) {
                    this.ifIframe = true;
                }
            },
        },
    };
</script>
<!-- script -->
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .modalIframe .modalIframeInner .carousel-inner {
        filter: drop-shadow(8px 10px 19px rgba(0, 0, 0, 0.09));
        border-radius: 5px;
    }

    @media screen and (min-width: 600px) {
        .modalIframe .modalIframeInner {
            max-width: 420px;
        }
    }

    @media screen and (min-width: 700px) {
        .modalIframe .modalIframeInner {
            max-width: 470px;
        }
    }

    @media screen and (min-width: 800px) {
        .modalIframe .modalIframeInner {
            max-width: 510px;
        }
    }
</style>
